import { CardTitle } from '@/components/Shares/CardTitle';
import { CarouselLayout } from '@/components/Shares/CarouselLayout';
import { useLingui } from '@lingui/react';
import { Carousel } from '@mantine/carousel';
import { Box } from '@mantine/core';
import { RecentlyPlayedCard } from './RecentlyPlayedCard';
import { biggest, recently } from './data';
export const RecentlyPlayedGames: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Box mt={20} maw={{
    md: '62em',
    lg: '75em',
    xl: '88em'
  }}>
      <CarouselLayout id="biggest-stats" items={biggest} isShadow title={<CardTitle firstText={i18n._('Recently played')} isFirstGradient colorFrom="#B9C7D4" colorTo="#B9C7D4" iconUrl="/assets/title-icons/6.png" mt={6} />} slideSize={{
      base: '40%',
      sm: '22%',
      md: '20%',
      xl: '13.33%'
    }}>
        {recently.map(item => <Carousel.Slide key={item.id}>
            <RecentlyPlayedCard {...item} />
          </Carousel.Slide>)}
      </CarouselLayout>
    </Box>;
};